import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9e96fd2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "profile-info"
}
const _hoisted_2 = { class: "profile-info__about" }
const _hoisted_3 = { class: "profile-info__photo" }
const _hoisted_4 = { class: "profile-info__about-main-info" }
const _hoisted_5 = { class: "medium mb--15" }
const _hoisted_6 = { class: "mb--15 items-in-line flex-start" }
const _hoisted_7 = { class: "mb--15 items-in-line flex-start" }
const _hoisted_8 = { class: "mb--15" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "medium" }, "Роль: ", -1))
const _hoisted_10 = { class: "mb--15" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "medium" }, "Город: ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "medium" }, "ID: ", -1))
const _hoisted_13 = { class: "profile-info__about-description" }
const _hoisted_14 = { class: "profile-info__company-name mb--15" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "medium" }, "Название компании: ", -1))
const _hoisted_16 = { class: "profile-info__company-name mb--15" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "medium" }, "Сайт компании: ", -1))
const _hoisted_18 = ["href"]
const _hoisted_19 = {
  key: 0,
  class: "items-in-column flex-start"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "medium" }, "Логотип: ", -1))
const _hoisted_21 = { class: "center allBlockWidth" }
const _hoisted_22 = { class: "profile-info__btns" }
const _hoisted_23 = { class: "grid--1 gap--20 mb--20" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-size-title-block" }, "Пароль успешно изменен", -1))
const _hoisted_25 = { class: "center" }

import { computed, onMounted, ref } from 'vue';
import ChangePassword from '@/components/AuthComponents/ChangePassword.vue';
import { useRouter } from 'vue-router';
import { UserType, useUserStore } from '@/store/modules/user';
import { preparePhone } from '@/utils/Common/Common';
import { useAppStore } from '@/store/modules/app';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileInfo',
  setup(__props) {

const showChangePassModal = ref(false);
const showSuccessInfoModal = ref(false);
const router = useRouter();

const userInfo = computed((): UserType | undefined => {
  return useUserStore().user;
});
const showSuccessChangePassInfo = () => {
  showChangePassModal.value = false;
  showSuccessInfoModal.value = true;
};

const goToLogin = () => {
  showSuccessInfoModal.value = false;
  useAppStore().openAuthModal();
  router.push({ name: 'main' });
  useUserStore().writeUserInfo(null);
};

const userType = computed((): number | undefined => {
  return useUserStore().user?.type;
});

onMounted(() => {
  if (!userInfo.value) {
    useAppStore().openAuthModal();
    router.push({ name: 'main' });
  }
});

return (_ctx: any,_cache: any) => {
  const _component_base_image = _resolveComponent("base-image")!
  const _component_base_divider = _resolveComponent("base-divider")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (userInfo.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_base_image, {
                contain: !userInfo.value.logo,
                cover: !!userInfo.value.logo,
                height: userInfo.value.logo ? '80' : '50',
                src: userInfo.value.logo || require('@/assets/img/profile/avatar.png'),
                width: userInfo.value.logo ? '80' : '50',
                name: "ava"
              }, null, 8, ["contain", "cover", "height", "src", "width"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(userInfo.value.name || 'Имя пользователя'), 1),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", null, [
                  _createVNode(_component_base_image, {
                    src: require('@/assets/img/profile/icon-tel.png'),
                    class: "tertiaryLightColorFilter",
                    contain: "",
                    height: "21",
                    name: "tel",
                    width: "21"
                  }, null, 8, ["src"])
                ]),
                _createTextVNode(_toDisplayString(_unref(preparePhone)(userInfo.value.phone) || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", null, [
                  _createVNode(_component_base_image, {
                    src: require('@/assets/img/profile/icon-mail.png'),
                    class: "tertiaryLightColorFilter",
                    contain: "",
                    height: "21",
                    name: "mail",
                    width: "21"
                  }, null, 8, ["src"])
                ]),
                _createTextVNode(_toDisplayString(userInfo.value.email || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("span", null, _toDisplayString(_unref(useAppStore)().getType()), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("span", null, _toDisplayString(userInfo.value.region), 1)
              ]),
              _createElementVNode("button", {
                class: "gradient-color mb--15",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showChangePassModal.value = true))
              }, " Сменить пароль "),
              _createElementVNode("div", null, [
                _hoisted_12,
                _createElementVNode("span", null, _toDisplayString(userInfo.value.id), 1)
              ])
            ]),
            _withDirectives(_createVNode(_component_base_divider, {
              class: "profile-info__about-divider",
              vertical: ""
            }, null, 512), [
              [_vShow, userType.value !== 1]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("span", null, _toDisplayString(userInfo.value.profile.titleCompany || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("a", {
                  href: userInfo.value.profile.siteCompany,
                  target: "_blank"
                }, _toDisplayString(userInfo.value.profile.siteCompany || '-'), 9, _hoisted_18)
              ]),
              (userInfo.value.profile.logoCompany)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_base_image, {
                        src: userInfo.value.profile.logoCompany,
                        class: "profile__content-avatar",
                        contain: "",
                        height: "80",
                        name: "ava",
                        width: "150"
                      }, null, 8, ["src"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 512), [
              [_vShow, userType.value !== 1]
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_base_button, {
              href: { query: { menuItem: 'editProfile' } },
              height: "36",
              text: "Редактировать",
              width: "191"
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_base_modal, {
      "show-modal": showChangePassModal.value,
      "hide-title": "",
      onClose: _cache[1] || (_cache[1] = ($event: any) => (showChangePassModal.value = false))
    }, {
      content: _withCtx(() => [
        _createVNode(ChangePassword, { onClose: showSuccessChangePassInfo })
      ]),
      _: 1
    }, 8, ["show-modal"]),
    _createVNode(_component_base_modal, {
      "show-modal": showSuccessInfoModal.value,
      "close-outside": "",
      "hide-titles": "",
      onClose: _cache[2] || (_cache[2] = ($event: any) => (showSuccessInfoModal.value = false))
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_base_button, {
              height: "40",
              text: "Ок",
              onClick: goToLogin
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["show-modal"])
  ], 64))
}
}

})